module.exports = __webpack_public_path__ + "img/pole-homepage-bottom.050dec5d.webp";